import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-students-feedback-form',
  templateUrl: './students-feedback-form.component.html',
  styleUrls: ['./students-feedback-form.component.scss']
})
export class StudentsFeedbackFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
